import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { catchError, map, Observable, take } from 'rxjs';
import { SearchPagesRequest } from './search-pages.model';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class SearchPagesAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  fetch(query: string, pageNumber: number): Observable<SearchPagesRequest> {
    const params: { [key: string]: string } = {};

    if (pageNumber) {
      params['currentPage'] = pageNumber.toString();
    }

    params['query'] = query;

    const url = this.occEndPointService.buildUrl('contentSearch', { queryParams: params });
    return this.http.get(url).pipe(
      take(1),
      map((data: any) => ({
        ...this.normalize(data),
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  normalize(data: any): SearchPagesRequest {
    const searchResult: SearchPagesRequest = {
      pages: (data.contents || []).map((page: any) => ({
        title: page.title || '',
        description: page.content || '',
        url: page.label || '/',
      })),
      pagination: data?.pagination,
    };

    return searchResult;
  }
}
